import { BodyFootProps, TableDataTypes, TheadType } from '../../Table/table.types';
import { SortOrderTypes } from '../dataTable.types';

type validDataType = string | number | Date | boolean;

interface columnSortPropsProps {
  sortField: string,
  type: string,
  sortOrder: string;
};

class DataTableStore {

  tableRows: BodyFootProps[]; // The table rows data
  columns: any; // The column head data
  sortColumnIndex: number; // The currently sorted index

  constructor (rowData: any, columnData: any, sortIndex: number) {
    this.tableRows = rowData;
    this.columns = columnData;
    this.sortColumnIndex = sortIndex;
  }

  // Set the current sort info
  setSortInfo (columnIndex: number, sortColumn: TheadType) {
    this.columns[`col-${columnIndex}`] = sortColumn;
    this.sortColumnIndex = columnIndex;
    this._refresh();
  }

  // Return the table data
  getTableRows () {
    return this.tableRows;
  }

  // Sort the data
  _refresh (skipSorting?: boolean) {
    if (!skipSorting) {
      this.sort();
    }
  }

  // Call the sort function
  sort () {
    this._sort();
  }

  // Determine if the object is a Date object
  _isDate (date: any) {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
  };

  // Convert the prop to its correct data type
  _convertType (prop: any, dataType: string) {
    switch (dataType) {
    case TableDataTypes.STRING:
      prop = prop ? (prop as string).toLowerCase() : prop;
      break;
    case TableDataTypes.NUMBER:
      prop = parseFloat((prop as string));
      prop = isNaN(prop) ? 0 : prop;
      break;
    case TableDataTypes.DATE:
      prop = (this._isDate(prop)) ? prop.valueOf() : prop;
      break;
    case TableDataTypes.BOOLEAN:
      prop = !!prop;
      break;
    }
    return prop;
  };

  // Compare a and b
  _compare (a: validDataType, b: validDataType) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else if ((a === undefined && b === undefined) || a === b) {
      return 0;
    } else if (a === undefined) {
      return -1;
    } else if (b === undefined) {
      return 1;
    } else {
      return 0;
    }
  };

  // Sort the table data if we have a current sort column to look at
  _sort () {
    if (this.sortColumnIndex) {
      const index = this.sortColumnIndex;
      const sortColumn = this.columns[`col-${index}`];

      const sortState = sortColumn && sortColumn.sortState;
      const sortMultiFirst = sortColumn.sortMultiFirst || false;
      const sortColumns = sortColumn.sortColumns.slice();
      let columnSortProps: columnSortPropsProps[] = [];
      let column;

      // add current column to be sorted
      if (sortMultiFirst) {
        sortColumns.push({columnIndex: index, sortOrder: sortState});
      } else {
        sortColumns.unshift({columnIndex: index, sortOrder: sortState});
      }

      // Record each of the columns we'll be using to compare via the "sortColumns" key
      for (let i = 0; i < sortColumns.length; i++) {
        const {
          columnIndex,
          sortOrder
        } = sortColumns[i];
        console.log(columnIndex, sortOrder)
        column = this.columns[`col-${columnIndex}`];
        columnSortProps.push({
          sortField: column.sortField || column.dataField,
          type: column.type,
          sortOrder: sortOrder
        });
      }

      const convertType = this._convertType.bind(this);
      const compare = this._compare.bind(this);
    
      this.tableRows.sort((a, b) => {
        let i = 0;
        let result = 0;
        let numberOfProperties = columnSortProps.length;
        
        // While the result is still not determined and there are more column values to use
        // for comparison, keep checking.
        while (result === 0 && i < numberOfProperties) {
          const {
            sortField,
            type,
            sortOrder
          } = columnSortProps[i];
          const aVal = convertType(a[sortField], type);
          const bVal = convertType(b[sortField], type);
          const order = sortOrder === 'toggle' ? columnSortProps[0].sortOrder : sortOrder;

          result = compare(aVal, bVal);
          result = (order === SortOrderTypes.DESC) ? (0 - result) : result;
          i++;
        }

        return result;
      });
    }
  }

  // Retrieve the data needed for the table
  get (rowData: BodyFootProps[], sortColumnIndex: number, sortColumn: TheadType) {
    this.tableRows = rowData;
    this.setSortInfo(sortColumnIndex, sortColumn);
    this._refresh();
    const _data = this.getTableRows();
    return _data;
  }
}

export default DataTableStore;
